import axios from './axios-instance';

export function fetchPage(params) {
  return axios.get('/unioncenter/web-background/account/get-page', { params });
}

export function fetchDetail(payload) {
  return axios.post('/unioncenter/account/detail', payload);
}

export function fetchProductStoreList(payload) {
  return axios.post('/unioncenter/product/storeList', payload);
}

export function add(payload) {
  return axios.post('/unioncenter/web-background/account/create', payload);
}

export function edit(payload = {}) {
  return axios.post('/unioncenter/web-background/account/edit', payload);
}

export function updateStatus({ status, accountName }) {
  return axios.get(`/unioncenter/web-background/account/${status}`, { params: { accountName } });
}

export function del(params = {}) {
  return axios.get('/unioncenter/web-background/account/delete', { params });
}

export function unLock(params = {}) {
  return axios.get('/unioncenter/web-background/account/unLock', { params });
}

export function fetchFormatList(payload = {}) {
  return axios.get('/unioncenter/common/format/list', payload);
}

export function fetchCityList(payload = {}) {
  return axios.get('/unioncenter/common/province/list', payload);
}

export function fetchStoreList(payload = {}) {
  return axios.post('/unioncenter/management/store/list', payload);
}

export function getChannelList(data) {
  return axios({
    method: 'post',
    url: '/unioncenter/auth/storeChannelSalesman/list',
    data,
  });
}

export function getMerchantTree(data) {
  return axios({
    method: 'post',
    // url: '/unioncenter/auth/tenant/organization/list',
    url: '/unioncenter/auth/tenant/organization/queryTenantOrganization',
    data,
  });
}
// 批量导入渠道账号
export function apiBatchCreateChannel(data) {
  return axios({
    method: 'post',
    url: '/unioncenter/auth/background/channel/account/batch-create',
    data,
  });
}
// 导出账号
export function apiExportAccount(data) {
  return axios({
    method: 'post',
    url: '/report/auth/channel-account/excel/download',
    data,
  });
}
